import { Box, Flex, Text } from "@mantine/core";

import { GlossaryItemType } from "~/utils/Types";

import Link from "./Link";

import classes from "./GlossaryItem.module.css";

const GlossaryItem = ({ item }: { item: GlossaryItemType }) => (
  <Flex direction="column">
    {item.link ? (
      <Box>
        <Link
          href={item.link}
          target="_blank"
          fz="md"
          fw={600}
          underline="never"
          className={classes.titleLink}
        >
          {item.title}
        </Link>
      </Box>
    ) : (
      <Text fw={600}>{item.title}</Text>
    )}
    <Text>{item.content}</Text>
    {item.extra}
  </Flex>
);

export default GlossaryItem;
